import { Dropdown } from 'antd';
import './DropdownFilter.scss';
import { Space } from 'antd';
import { Icon } from '../../icon/icon';

const DropdownFilter = ({ value, icon, size = 'default', ...props }) => {
  return (
    <Dropdown
      trigger={['click']}
      {...props}
      className={
        'custom-dropdown rounded-[4px] flex-row justify-center ' +
        (size === 'default'
          ? 'px-[12px] py-[7px] '
          : size === 'small'
            ? 'px-[8px] py-[5px] '
            : 'px-[12px] py-[10px] ') +
        props?.className
      }
    >
      <Space className={'flex items-center'}>
        {icon ? <span className="w-[14px] h-[14px] flex">{icon}</span> : null}
        <span
          className={
            'text-nowrap ' +
            (size === 'default'
              ? 'text-body-medium'
              : size === 'small'
                ? 'text-body-small'
                : 'text-body-large')
          }
        >
          {value}
        </span>
        <span
          className={
            'icon--expand flex ' +
            (size === 'default'
              ? 'w-[18px] h-[18px]'
              : size === 'small'
                ? 'w-[14px] h-[14px]'
                : 'w-[20px] h-[20px]')
          }
        >
          <Icon.ICExpandMore />
        </span>
      </Space>
    </Dropdown>
  );
};

export default DropdownFilter;
